import { inject, Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { PrivacyService } from "../../services/privacy.service";

@Injectable({
    providedIn: 'root'
  })
  export class PrivacyGuard implements CanActivate {

    privacyService = inject(PrivacyService)
    router = inject(Router)
  
    constructor() { }
  
    canActivate(): boolean {
      if (this.privacyService.isPrivacyApproved()) {
        return true;
      } else {
        this.router.navigate(['/']); // reindirizza alla pagina privacy se non ha cliccato
        return false;
      }
    }
  }